import React from "react";
import { NodeViewWrapper } from "@tiptap/react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";

export default function LSDBButtonView(props: any) {
  const { node, getPos } = props;

  console.log("LSDB Button Rendered", {
    attributes: node?.attrs,
    position: typeof getPos === "function" ? getPos() : "unknown",
  });

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    console.log("LSDB Button Clicked in Editor:", {
      node,
      position: typeof getPos === "function" ? getPos() : "unknown",
    });
  }

  const alignment = node?.attrs?.alignment || "right";

  const getJustifyContent = () => {
    if (alignment === "center") return "center";
    if (alignment === "right") return "flex-end";
    return "flex-start";
  };

  if (!node) return null;

  return (
    <NodeViewWrapper
      as="div"
      className="lsdb-button-node"
      contentEditable={false}
      style={{
        display: "flex",
        width: "100%",
        justifyContent: getJustifyContent(),
        alignItems: "center",
        margin: "4px 0",
      }}
    >
      <Tooltip title="Fetch data from LSDB">
        <IconButton size="small" color="primary" onClick={handleClick}>
          <img
            src="/fetch_lsdb.png"
            alt="Fetch from LSDB"
            style={{
              width: 24,
              height: 24,
              display: "block",
              objectFit: "contain",
            }}
          />
        </IconButton>
      </Tooltip>
    </NodeViewWrapper>
  );
}